export default __webpack_public_path__ + "static/media/ios_add.cfe2c9b0.svg";